import { DataColumn, DataType } from '../../types';

export function validColumnsFilter(col: DataColumn): boolean {
  return (col.dataType === DataType.Decimal || col.dataType === DataType.Integer) && col.arrayLength !== null;
}
